import styled from 'styled-components'

export const FooterAction = styled.div`
  display: flex;
  justify-content: flex-start;
`
